import startCase from 'lodash/startCase';

import { addUserAction } from 'modules/tracking/providers/user-action-provider';

import { QUERY, REPORT } from '../utils/sov';

import type { SOVGeneralEventType, SOVGeneralSectionType } from 'modules/insights/sov/types';

const getTrackingString = (
  eventType: SOVGeneralEventType,
  sectionType: SOVGeneralSectionType,
  trackingType?: string | null
): string => `sov-${sectionType}-${eventType}--${String(trackingType)}`;

export const trackSOVEvent = (
  eventType: SOVGeneralEventType,
  sectionType: SOVGeneralSectionType,
  trackingType: string | undefined | null,
  brandProfileId: number | undefined | null,
  trackingId: number
): void => {
  const trackingTypeLabel = sectionType === QUERY ? QUERY : REPORT;
  const trackingTypeString = `${startCase(trackingTypeLabel)} ID: ${String(trackingId) || 'null'}`;
  const data = `Brand Profile ID: ${String(brandProfileId || 'null')}, ${trackingTypeString}`;
  const trackingString = getTrackingString(eventType, sectionType, trackingType);

  addUserAction({
    eventCategory: 'share-of-voice',
    eventAction: trackingString,
    eventLabel: data
  });
};
